import React from "react";
import { AiFillCaretDown } from "react-icons/ai";
import { MenuOutlined } from "@ant-design/icons";
import { HeaderContainer, NavLinks, MenuBtn } from "./index.style";
import { useNavigate } from "react-router-dom";
import { Dropdown } from "antd";
import { useDispatch } from "react-redux";
import { logout } from "../../redux/authSlice";

const Header = ({ onMenuClick }) => {
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const items = [
		{
			label: (
				<div
					onClick={() => {
						dispatch(logout());
						navigate("/login");
					}}
				>
					Logout
				</div>
			),
			key: "1",
		},
		{
			label: <a href='/setting/change-password'>Change Password</a>,
			key: "2",
		},
	];
	return (
		<HeaderContainer>
			<MenuBtn onClick={onMenuClick}>
				<MenuOutlined />
			</MenuBtn>
			<NavLinks>
				<Dropdown
					menu={{
						items,
					}}
					trigger={["click"]}
				>
					<a onClick={(e) => e.preventDefault()}>
						Admin
						<AiFillCaretDown style={{ marginLeft: 6, fontSize: 12 }} />
					</a>
				</Dropdown>
			</NavLinks>
		</HeaderContainer>
	);
};

export default Header;
